import { Slide } from '@/shared/types/interactive-bible-slides.ts';
import type { RouteRecordRaw } from 'vue-router';

export type Maybe<T> = T | undefined;

export type MaybeNull<T> = T | null;

export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export type ID = string;

export interface Roadmap {
  bibleBookId: string;
  chapterNumber: number;
  entrypointId: ID;
  id: ID;
  items: RoadmapElement[];
  name: string;
}

export interface RoadmapElement {
  backgroundAudio?: BackgroundAudio;
  slideId: ID;
  name: string;
  children: RoadmapChildElement[];
}

export interface RoadmapChildElement {
  backgroundAudio?: BackgroundAudio;
  slideId: ID;
  groupId: ID;
  volume: number;
}

export interface RoadmapItemGroup {
  id: ID;
  nextId: MaybeNull<ID>;
  prevId: MaybeNull<ID>;
}

export type NavigationKey = 'nextId' | 'prevId' | 'childId' | 'parentId';

export interface NavigationMask {
  up: MaybeNull<NavigationKey>;
  down: MaybeNull<NavigationKey>;
  left: MaybeNull<NavigationKey>;
  right: MaybeNull<NavigationKey>;
}

interface BackgroundAudio {
  groupId: ID;
  volume?: number;
}

export interface IRoadmapItem {
  id: ID;
  slideId: ID;
  groupId: ID;
  siblingGroups: ID[];
  nextId: MaybeNull<ID>;
  prevId: MaybeNull<ID>;
  childId: MaybeNull<ID>;
  prevChildId: MaybeNull<ID>;
  parentId: MaybeNull<ID>;
  navigationMask: NavigationMask;
  slide: Slide;
  children?: ID[];
  backgroundAudio?: BackgroundAudio;
  roadmapId: ID;
  order: number;
}

export interface MountedRoadmapItem extends IRoadmapItem {
  ref$: MaybeNull<HTMLElement>;
  rendered: boolean;
}

export enum AppScreens {
  Home = 'Home',
  InviteVillage = 'InviteVillage',
  Onboarding = 'Onboarding',
  InviteWelcome = 'InviteWelcome',
  InteractiveBible = 'InteractiveBible',
  Stories = 'Stories',
  Story = 'Story',
  PrayerExperience = 'PrayerTalks',
  VideoBible = 'VideoBible',
  ReadingPlans = 'ReadingPlans',
  ReadingPlanDetail = 'ReadingPlanDetail',
  ReadingPlanDay = 'ReadingPlanDay',
  Courses = 'Courses',
  Menu = 'Menu',
  Login = 'Login',
  Profile = 'Profile',
  None = 'None',
  IconsPreview = 'IconsPreview',
  TextBible = 'TextBible',
}

export interface AppModule {
  routes?: Record<string, RouteRecordRaw>;
}
